import { render, staticRenderFns } from "./CoachAgreement.vue?vue&type=template&id=1bf7483c&scoped=true&"
import script from "./CoachAgreement.vue?vue&type=script&lang=js&"
export * from "./CoachAgreement.vue?vue&type=script&lang=js&"
import style0 from "./CoachAgreement.vue?vue&type=style&index=0&id=1bf7483c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7483c",
  null
  
)

export default component.exports